/**
 * Input Data Types
 * str - string
 * num - number
 * bol - boolean
 * drp - dropdown string
 * ofd - object further down
 */

const schema = {
  gender: "Male",
  full_name: "",
  current_address_address: "",
  current_address_city: "",
  current_address_state: "Alabama",
  current_address_country: "United States",
  current_address_zip_code: "",
  native_address_address: "",
  native_address_city: "",
  native_address_state: "Tamil Nadu",
  native_address_country: "India",
  native_address_zip_code: "",
  contact: "",
  email: "",
  education: "",
  working: "no",
  work_location: "",
  salary: 0,
  zodiac_star: "",
  caste: "Kannada Devaga Chettiyar",
  division: "Allikondaar",
  sub_division: "Aananda Bairavi Mahirishi",
  special_mention: "",
  horoscope: "",
  photo: "",
  contact_person: "",
  contact_person_phone: "",
  contact_person_email: "",
  age: 0,
};

export default schema;
